import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, message, Radio, Row } from "antd";
import BirthDayDatePicker from "./BirthDayDatePicker";
import persianDate from "persian-date";
import {
  getArrayPersianDate,
  isNumber,
  // validateNationalCode,
} from "../../../constant/helper";
import { updateProfile } from "../profile.api";
// import CustomInputJustDigit from "./CustomInputJustDigit";

const FormData = (props) => {
  const { profile, fetchProfile } = props;
  // eslint-disable-next-line
  const [birthday, setBirthday] = useState(false);
  const [email, setEmail] = useState("");
  const [emailIsValidated, setEmailIsValidated] = useState(false);
  const [form] = Form.useForm();
  // TODO: set initial values for form
  useEffect(() => {
    if (profile?.email) {
      setEmail(profile?.email);
      setEmailIsValidated(true);
      form.setFieldsValue({ email: email });
    } else if (profile?.extraInfo?.additional?.email) {
      setEmail(profile?.extraInfo?.additional?.email);
      setEmailIsValidated(false);
      form.setFieldsValue({ email: email });
    } else {
      setEmail("");
      setEmailIsValidated(false);
    }
  }, [email, form, profile]);

  const onFinish = (values) => {
    let bDate = values.extraInfo.birthDay
      ? !isNumber(values.extraInfo.birthDay)
        ? new persianDate(
            getArrayPersianDate(values.extraInfo.birthDay)
          ).valueOf()
        : values.extraInfo.birthDay
      : "";

    let data = {
      ...profile,
      // email: values.email,
      extraInfo: {
        firstName: values.extraInfo.firstName,
        // nationalCode: values.extraInfo.nationalCode,
        // economicCode: values.extraInfo.economicCode,
        avatarImageUrl:
          profile.hasOwnProperty("extraInfo") && profile.extraInfo != null
            ? profile.extraInfo?.avatarImageUrl
            : "",
        gender: values.extraInfo.gender,
        tag: "client",
        birthDay: bDate, // TODO: convert to timestamp
        ...(!emailIsValidated && {
          additional: {
            email: values.email,
          },
        }),
        ...(emailIsValidated && {
          email: values.email,
        }),
      },
    };

    updateProfile(data)
      .then((response) => {
        message.success("تغییرات اعمال شد!");
        fetchProfile();
      })
      .catch((error) => {
        message.error("خطا در ارسال");
      });
  };
  return (
    <>
      <div className="form-title">
        <h3 className={"title"}> اطلاعات کاربر </h3>
      </div>
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={{
          ...profile,
          email,
        }}
      >
        <div className="email">
          <Form.Item
            name={["extraInfo", "firstName"]}
            rules={[
              { required: true, message: "نام خود را وارد نمائید" },
              { min: 2, message: "نام خود را صحیح وارد نمائید" },
            ]}
            hasFeedback
          >
            <Input placeholder={"نام و نام خانوادگی"} />
          </Form.Item>

          <Form.Item
            name={"email"}
            readonly={emailIsValidated}
            rules={[
              {
                type: "email",
                message: "ایمیل خود را به صورت صحیح وارد نمائید",
              },
            ]}
            hasFeedback
          >
            <Input placeholder={"ایمیل"} readOnly={emailIsValidated} />
          </Form.Item>
        </div>
        <div className="data">
          {/* <Form.Item
            name={["extraInfo", "nationalCode"]}
            rules={[
              {
                validator: validateNationalCode,
                message: "کد ملی وارد شده صحیح نمی باشد",
              },
            ]}
          >
            <CustomInputJustDigit placeholder={"کد ملی"} min={0} max={10} />
          </Form.Item>
          <Form.Item
            name={["extraInfo", "economicCode"]}
            rules={[
              {
                pattern: new RegExp("^([0-9]){12}$"),
                message: "مقدار وارد شده صحیح نیست",
              },
            ]}
          >
            <CustomInputJustDigit placeholder={"کد اقتصادی"} min={0} max={12} />
          </Form.Item> */}
          <Row className={"half-inp"}>
            <Col span={12} className="right-text">
              <Form.Item name={["extraInfo", "birthDay"]}>
                <BirthDayDatePicker onChange={setBirthday} />
              </Form.Item>
            </Col>
            <Col span={12} className="left-text center-flex ">
              <Form.Item name={["extraInfo", "gender"]}>
                <Radio.Group>
                  <Radio value={"FEMALE"}>زن</Radio>
                  <Radio value={"MALE"}>مرد</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="submit-btn center-text">
          <Form.Item>
            <Button type="primary" shape="round" htmlType="submit">
              ثبت
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

export default FormData;
